import * as React from "react";
import { useRenderElement } from "../../internals/useRenderElement.js";
import { MenuGroupContext } from "./MenuGroupContext.js";
import { jsx } from "react/jsx-runtime";
const MenuGroup = /* @__PURE__ */ React.forwardRef(function MenuGroup2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const [labelId, setLabelId] = React.useState(void 0);
  const element = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    props: {
      role: "group",
      "aria-labelledby": labelId,
      ...elementProps
    }
  });
  return /* @__PURE__ */ jsx(MenuGroupContext.Provider, {
    value: setLabelId,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") MenuGroup.displayName = "MenuGroup";
export {
  MenuGroup
};
//# sourceMappingURL=MenuGroup.js.map
